import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=67c6540a"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports